export function stickyRow() {

    var filterRow = document.getElementById("filter-row");
    var hasBlockActive = document.getElementById("hasBlockId") != null;    
    var top = hasBlockActive ? 800 : 160;
    
    if (filterRow != null) {
        if (window.pageYOffset > top) {
          filterRow.classList.add("sticky");
          if (hasBlockActive) {
            filterRow.classList.add("size-change");
          }            
        } 
        else {
          filterRow.classList.remove("sticky");
          if (hasBlockActive) {
            filterRow.classList.remove("size-change");
          }  
            
        }
    }
}
